/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ICocMapViewerViewProps } from './coc-map-viewer';
import Iframe from 'react-iframe';
import { Modal, ModalBody } from 'reactstrap';

const Spinner: React.FC<{ text: string }> = ({ text }) => {
    return (
        <div className='spinner-wrap'>
            <div className='preload-spinner-container'>
                <div className='preload-spinner' role='status'></div>
                <p>{text}</p>
            </div>
        </div>
    );
};

export default (props: ICocMapViewerViewProps) => {
    const { isLoading, errorMessages, resetErrors } = props;
    const { loadingLabel, errorHeaderLabel, closeModalLabel } = props.resources;
    const isOpen = !!errorMessages.length;
    return (
        <>
            <Modal role='document' aria-labelledby='productSearchTitle' className='cui' isOpen={isOpen} toggle={resetErrors}>
                <div className='modal-header'>
                    <h2 id='productSearchTitle' tabIndex={0} className='modal-title'>
                        {errorHeaderLabel}
                    </h2>
                    <button className='btn-modal-close cui btn-md primary-text' onClick={resetErrors}>
                        {closeModalLabel}
                    </button>
                </div>
                <ModalBody>
                    <div className='cui alert-banner inline error'>
                        <div className='alert-body'>
                            <span className='alert-icon cicon-exclamation-triangle'></span>
                            <ul className='error-messages-list list-style-dot'>
                                {errorMessages.map(error => (
                                    <li aria-live='assertive' aria-label={error} role='alert' className='error-message-item' key={error}>
                                        {error}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
            {isLoading && <Spinner text={loadingLabel} />}
            <div className='row mapViewerBlock'>
                <Iframe url={props.config.mapViewerLink!} height='1000px' id='myId' className='mapViewer' position='relative' />
            </div>
        </>
    );
};
